import { AddEditData, UtilityService } from "./../../utility.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
import { ApiDataService } from "src/app/api-data.service";
import { Location } from '@angular/common';
@Component({
  selector: "app-customerdetail",
  templateUrl: "./customerdetail.component.html",
  styleUrls: ["./customerdetail.component.css"],
})
export class CustomerdetailComponent implements OnInit, AddEditData {
  objectAllList: Object;
  pristineALLData: Object;
  subUsers: any;
  subscriptions: any;
  user = JSON.parse(sessionStorage.getItem("etrLocUser"));
  constructor(
    private route: ActivatedRoute,
    private utility: UtilityService,
    private dataService: ApiDataService,
    private location: Location
  ) { }
  // step 1 : Assign section variable correctly
  // Step 2 : If EditMode validate and Bind Html input to this object using template driven forms (2-way Binding ([ngModel]))
  // Step 3 : If any Binary Data is uploaded add it to Binary Array
  // Step 4 : on Submit validate schema to be sent-->if valid upload Binary Array to S3 ,upon succes upload Form Data
  // Step 6 : Reset State of form after submit
  // CamelCase for naming anything
  // select this appropriately
  section = this.utility.apiData.etrUsers;
  imageSrc: any;
  object: any;
  isEditMode = false;
  isUploadingData = false;
  isLoadingData = false;
  binaryFiles = [];
  date = new Date;
  statusExists = false;
  @ViewChild("mainForm", { static: false }) mainForm: NgForm;
  ngOnInit() {
    this.resetForm();
    this.hasData();
    this.usersAllowed();
  }
  resetForm() {
    this.isUploadingData = false;
    this.isLoadingData = false;
    this.isEditMode = false;
    // change
    this.object = JSON.parse(JSON.stringify(this.section.object));
    this.object.etrID = this.user.etrID;
    this.object.etrLocID = this.user.etrLocID;
    this.imageSrc = null;
  }
  loadData(id) {
    //Get Form Data via API
    this.dataService.getData(this.section.ApiUrl, id).subscribe(
      (Response) => {
        if (!this.utility.dovValidateSchema.validate(Response, this.section.schema).valid) {
          swal("No data exists");
          this.location.back();
        }
        this.object = Response;
        if (('status' in this.object)) this.statusExists = true;
        this.isLoadingData = false;
      },
      (error) => {
        console.log(error);
        swal("No data exists");
        this.location.back();
      });
  }
  usersAllowed() {
    console.log(this.user);
    //Get Form Data via API
    this.dataService.getallData(this.section.ApiUrl + `?etrLocid=${this.user.etrLocID}`)
      .subscribe(Response => {
        let object: any = [];
        if (Response) {
          object = Response;
          if (object.length > this.user.maxUsers) {
            swal("Maximum Users Added");
            this.location.back();
          }
        }
      }, error => {
        swal("Unable to reset password,please try again");
        this.location.back();
      })
  }
  hasData() {
    this.route.paramMap.subscribe((params) => {
      if (params.get("id") && params.get("id") != "") {
        this.isLoadingData = true;
        this.isEditMode = true;
        this.loadData(params.get("id"));
      }
    });
  }
  uploadBinaryData() {
    this.object.imageSrc = ""; //only in cases where there is singular binding
    let requests = this.binaryFiles.map((object) => {
      console.log(object);
      return this.utility.uploadBinaryData(object["name"], object["binaryData"], this.section.bucket);
    });
    Promise.all(requests)
      .then((responses) => {
        this.object.imageSrc = responses[0]["name"];
        this.uploadFormData();
      })
      .catch((error) => {
        console.log(error);
        this.isUploadingData = false;
      });
  }
  uploadFormData() {
    //post request here,both add & update are sent as post.
    this.object.isEdit = this.isEditMode;
    this.dataService
      .postData(this.section.ApiUrl, JSON.stringify(this.object))
      .subscribe((Response) => {
        console.log(Response);
        this.isEditMode ? swal("User updated succesfully") : swal("User added succesfully");
        this.location.back();
      }, (error) => {
        switch (error.status) {
          case 406:
            swal("Failed to process request,E-mail address exists");
            break;
          case 407:
            swal("Failed to process request,Invalid Enterprise");
            break;
          case 407:
            swal("Failed to process request,Invalid Location");
            break;
          default:
          case 406:
            swal("Failed to process request,Server error");
            break;
        }
        console.log(error);
        this.isUploadingData = false;
      });
  }
  loadBinaryFile(event) {
    if (event.target.files.length > 0) {
      //reset binaryFiles array to this image --> S3 allows to directly upload file object or Blob data,for simplicity here file object is used
      this.binaryFiles = [
        { name: uuidv4(), binaryData: event.target.files[0] },
      ];
      //display selected file in image tag
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); //initiates converting file to blob
      reader.onload = (e) => (this.imageSrc = reader.result); // call back after file is converted to Blob
    }
  }
  onSubmit() {
    if (this.mainForm.invalid) {
      this.mainForm.form.markAllAsTouched();
      swal("Please enter values in the highlighted fields");
      return false;
    }
    this.isUploadingData = true;
    console.log(this.object);
    if (this.binaryFiles.length > 0) {
      this.uploadBinaryData();
    } else {
      this.uploadFormData();
    }
  }
  onDisable(isValididty) {
    //removed validity for the time being ,will be added later if busisness requirement comes forth-->back end is ready
    let object = {
      'isValidity': isValididty,
      'emailAddress': this.object.emailAddress,
      'status': !this.object.status,
      'userValid': !this.object.userValid
    };
    this.isUploadingData = true;
    this.dataService
      .putData(this.section.ApiUrl, JSON.stringify(object))
      .subscribe((Response) => {
        console.log(Response);
        swal("Details Updated Succesfully");
        this.location.back();
      }, (error) => {
        swal("Failed to process request,please try again");
        console.log(error);
        this.isUploadingData = false;
      });
  }
}